import { skyAt, skyForPhase, type SkyInfo, type SkyPhase } from '@iqrapath/shared'
import { useEffect, useState } from 'react'

const PHASES: SkyPhase[] = ['subuh', 'siang', 'maghrib', 'isya']

/** Dev-only QA override: `?sky=isya` (and `?lit=1|0` in the home page). Tree-shaken from production builds. */
function devOverride(): SkyInfo | null {
  if (!import.meta.env.DEV) return null
  const p = new URLSearchParams(window.location.search).get('sky')
  return p && (PHASES as string[]).includes(p) ? skyForPhase(p as SkyPhase) : null
}

/** Current sky in WIB, re-evaluated every minute and when the tab becomes visible again. */
export function useSky(): SkyInfo {
  const [sky, setSky] = useState<SkyInfo>(() => devOverride() ?? skyAt())
  useEffect(() => {
    const tick = () => { setSky((prev) => { const next = devOverride() ?? skyAt(); return next.label === prev.label ? prev : next }) }
    const id = window.setInterval(tick, 60_000)
    document.addEventListener('visibilitychange', tick)
    return () => { window.clearInterval(id); document.removeEventListener('visibilitychange', tick) }
  }, [])
  return sky
}

export function devLitOverride(): boolean | null {
  if (!import.meta.env.DEV) return null
  const v = new URLSearchParams(window.location.search).get('lit')
  return v === '1' ? true : v === '0' ? false : null
}
